<template lang="html">
  <section class="prt-switch">
    <slot />
    <button :aria-label="`Set switch to ${value ? off : on}`" :class="{active: value, icon: useIcons}" @click="$emit('input', !value)">
      <span :class="{active: !value, icon: useIcons}">
        <template v-if="!useIcons">{{off}}</template>
        <prt-icon v-else :icon="off" :width="14" :height="14" />
      </span>
      <span :class="{active: value, icon: useIcons}">
        <template v-if="!useIcons">{{on}}</template>
        <prt-icon v-else :icon="on" :width="14" :height="14" />
      </span>
    </button>
  </section>
</template>

<script>
import PrtIcon from './PrtIcon.vue';

export default {
  components: {
    PrtIcon,
  },
  props: {
    off: {
      default: 'Off',
      type: String,
    },
    on: {
      default: 'On',
      type: String,
    },
    useIcons: Boolean,
    value: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-switch
    display: flex
    width: calc(100% - 32px)
    max-width: 504px
    white-space: nowrap
    margin: 0 auto
    margin-bottom: 12px
    justify-content: space-between
    align-items: center

    button
      font-family: inherit
      font-size: 0.625rem
      font-weight: bold
      letter-spacing: 1px
      background-color: white
      border-radius: 20px
      box-shadow: 0 2px 4px black-12
      height: 40px
      margin-left: 16px
      border: none
      text-transform: uppercase
      padding: 0
      overflow: hidden
      position: relative
      outline: none

      &::after
        content: ''
        position: absolute
        display: block
        background-color: positive
        width: 50%
        height: 100%
        top: 0
        left: 0
        transition: transform 200ms ease

      &.active::after
        transform: translateX(100%)

      &.icon::after
        background-color: negative

      &.icon.active::after
        background-color: positive

      span
        width: calc(50% - 40px)
        margin: 0 20px
        display: inline-block
        color: black-54
        position: relative
        z-index: 1
        transition: color 200ms ease

        &.active
          color: white

        &.icon
          width: calc(50% - 24px)
          margin: 13px 12px
          line-height: 0
</style>
